//@flow
const genPageStateName = 'genPage'
const genPageSessionStore = sessionStorage.getItem(genPageStateName)

export const getStateName=(): string => {
    return genPageStateName
}

export const genPageInitialState: any = genPageSessionStore?JSON.parse(genPageSessionStore):{
	[genPageStateName]: { 
		root: {}
	}
}

type State = {
    +genPage: {
        root: any
    }
}

type Action = {
    error: string,
    pageDataId: string,
    pageData: any
}

export const TypePageDataFetch = 'pageDataFetch'
export const TypePageDataError = 'pageDataError'
export const TypePageDataReceived = 'pageDataReceived'

const getNewState = (state:State,pageDataId:string,pageData:any)=>{
    const thisState = {
        [genPageStateName]: {
            ...state[genPageStateName],
            root: {
                ...state[genPageStateName].root,
                [pageDataId]: pageData
            }
        }
    }

    sessionStorage.setItem(genPageStateName,JSON.stringify(thisState))
    return thisState  
}

export const genPageActions: any = {
    [TypePageDataFetch]: (state:State,action:Action) => {
        const dataRootState = state[genPageStateName].root[action.pageDataId]?state[genPageStateName].root[action.pageDataId]:{}
        let pageData = {...dataRootState}

        pageData = {
            ...pageData,
            error: '',
            loading: true,
        }

        const newState = getNewState(state,action.pageDataId,pageData)  
        return newState      
    },
    [TypePageDataError]: (state:State,action:Action) => {
        const dataRootState = state[genPageStateName].root[action.pageDataId]?state[genPageStateName].root[action.pageDataId]:{}
        let pageData = {...dataRootState}

        pageData = {
            ...pageData,
            error: action.error,
            loading: false,
        }

		return getNewState(state,action.pageDataId,pageData)
    },
    [TypePageDataReceived]: (state:State,action:Action) => {
        const dataRootState = state[genPageStateName].root[action.pageDataId]?state[genPageStateName].root[action.pageDataId]:{}
        let pageData = {
            ...dataRootState,
        }
        pageData = {
            ...pageData,
            error: '',
            loading: false,
            ...action.pageData
        }

        const newState = getNewState(state,action.pageDataId,pageData)  
		return newState 
    }
}